import { Box, Stack, Typography } from '@mui/material';

function AddressSearchOption({ props, option }: { props: any; option: any }) {
  return option.isCustom ? (
    <Stack
      key={option.id}
      direction="row"
      spacing={1}
      alignItems="center"
      sx={{
        my: '-8px',
        p: '12px 16px',
        '& a': {
          fontWeight: 700
        },
        '& .color-primary': { color: 'primary.main' },
        borderRadius: option.group === 'address' ? '0' : '0 0 8px 8px',
        border: '2px solid white',
        borderTop: 'none'
      }}
    >
      <Typography variant="body2" dangerouslySetInnerHTML={{ __html: option.label }} />
    </Stack>
  ) : (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <Box data-cy="address-search-option" component="div" {...(props as any)} key={option.id}>
      {option.label}
    </Box>
  );
}

export default AddressSearchOption;
